var _class;
import { observer } from "mobx-react";
import { Component } from "react";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import { jsx as _jsx } from "react/jsx-runtime";
let InfoParameterEditor = observer(_class = class InfoParameterEditor extends Component {
  render() {
    return /*#__PURE__*/_jsx("div", {
      children: this.props.parameter.value && parseCustomMarkdownToReact(this.props.parameter.value)
    });
  }
}) || _class;
export { InfoParameterEditor as default };